import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerCoefficientList from './reducers/reducerCoefficientList';

interface ICoefficientsReducers {
    coefficients: Reducer<any, AnyAction>;
}

const ContractsStore = combineReducers<ICoefficientsReducers>({
    coefficients: reducerCoefficientList
});

export default ContractsStore;